import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from 'file-saver';
export default class HarGharVikas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            response: null,
            postCount: 0,
            status: "Active",
            // lastEvaluatedKey: "",
            loadMoreDisplay: false,
            selectedPhotos: [],
            isChecked: false,
        };
        this.update = this.update.bind(this);
        this.getPosts = this.getPosts.bind(this);
        this.batchUpdate = this.batchUpdate.bind(this);
        this.selectToggle = this.selectToggle.bind(this);
    }
    componentDidMount() {
        var status = this.props.match.params.status;
        if (!status) {
            status = "enabled";
        }

        this.getPosts(status);
    }
    componentWillReceiveProps(nextProps) {
        var status = nextProps.match.params.status;
        if (!status) {
            status = "enabled";
        }
        this.setState({ lastEvaluatedKey: "" }, () => {
            this.getPosts(status);
        });
    }
    getPosts(status, loadmore) {
        $("#loader").css({ display: "block" });
        var ref = this;
        if (!loadmore) {
            ref.setState({ items: [] });
        }
        var request = doRequest(
            "cms-operations2",
            {
                action: "list-posts",
                module: "beneficiary2023",
                model: "post",
                lastEvaluatedKey: ref.state.lastEvaluatedKey,
                data: {
                    direction: "desc",
                    status: status,
                    limit: 100,
                },
            },
            true
        );
        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    let loadMoreItems = loadmore
                        ? [...ref.state.items, ...response.items]
                        : response.items;
                    if (response.items.length > 99) {
                        ref.setState({
                            loadMoreDisplay: true,
                        });
                    } else {
                        ref.setState({
                            loadMoreDisplay: false,
                        });
                    }
                    ref.setState(
                        {
                            response: response,
                            items: loadMoreItems,
                            lastEvaluatedKey: response.lastEvaluatedKey,
                            postCount: response.countdata.Count,
                            status: status,
                        },
                        () => {
                            $("#loader").css({ display: "none" });
                        }
                    );
                }
            } catch (ex) { }
        });
    }
    batchUpdate(status) {
        var ids = [];
        var createds = [];
        $(".multi_select:checked").each(function () {
            ids.push($(this).attr("data-id"));
            createds.push($(this).attr("data-created"));
        });
        var id = ids.join(",");
        var created = createds.join(",");

        if (id == "") {
            alert("No post selected");
        } else {
            this.update(id, created);
        }
    }

    update(id, created, status) {
        id = "" + id;
        var request = doRequest(
            "cms-operations2",
            {
                action: "update-post",
                module: "beneficiary2023",
                model: "post",
                data: {
                    id: id.toString(),
                    status: status,
                    created: created,
                },
            },
            true
        );

        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    $("#post_" + id).hide();
                }
            } catch (ex) { }
        });
    }

    enterPressed = (event, field) => {
        var code = event.keyCode || event.which;
        if (code === 13) {
            let ep = null;
            if (field == 1 && this.input1.value) {
                ep = {
                    action: "search-message",
                    module: "beneficiary2023",
                    model: "post",
                    data: { value: this.input1.value },
                };
            } else if (field == 2 && this.input2.value) {
                ep = {
                    action: "search-message",
                    module: "myseva",
                    model: "post",
                    data: { value: this.input2.value },
                };
            }

            if (ep) {
                var status = this.props.match.params.status;
                if (!status) {
                    status = "enabled";
                }
                let ref = this;
                var request = doRequest("cms-operations2", ep, true);
                request.addEventListener("load", function () {
                    var response = this.responseText;
                    try {
                        response = JSON.parse(response);
                        if (response._resultflag && response._resultflag == 1) {
                            console.log(response.Count);
                            ref.setState(
                                {
                                    response: response,
                                    items: response.items,
                                    lastIndex: response.lastEvaluatedKey,
                                    postCount: response.countdata.Count,
                                    status: status,
                                },
                                () => {
                                    $("#loader").css({ display: "none" });
                                }
                            );
                        }
                    } catch (ex) { }
                });
            }
        }
    };

    loadMoreData = () => {
        let ep = null;
        var status = this.props.match.params.status;
        this.getPosts(status ? status : "enabled", "loadmore");

    };

    selectToggle() {
        if ($(".allChecked").length > 0) {
            $(".multi_select").prop("checked", false);
            $(".multi_select").removeClass("allChecked");
        } else {
            $(".multi_select").prop("checked", true);
            $(".multi_select").addClass("allChecked");
        }
    }
    handlePhotoSelect = (photoId) => {
        const { selectedPhotos } = this.state;
        if (selectedPhotos.includes(photoId)) {
            this.setState({ selectedPhotos: selectedPhotos.filter((id) => id !== photoId) });
        } else {
            this.setState({ selectedPhotos: [...selectedPhotos, photoId] });
        }
    };

    downloadSelectedPhotos = () => {
        const { items } = this.state;
        const { selectedPhotos } = this.state;
        if (selectedPhotos.length > 5) {
            alert("You can download a maximum of 5 photos at once.");
            return;
        }
        selectedPhotos.forEach((id) => {
            const photo = items.find((p) => p.id === id);
            if (photo) {
                const fileUrl = photo.imageUrl;
                const fileName = `${photo.name}`
                saveAs(fileUrl, fileName);

            }
        });
    };

    UnselectChekbox = () => {
        this.setState({ selectedPhotos: [] })
    }
    downloadPhotos = (photo) => {
        saveAs(photo.imageUrl, photo.name);
    };

    flagreport = (flag, loadmore) => {
        $("#loader").css({ display: "block" });
        var ref = this;
        if (!loadmore) {
            ref.setState({ items: [] });
        }
        var request = doRequest(
            "cms-operations2",
            {
                action: "flag-content",
                module: "beneficiary2023",
                model: "post",
                // lastEvaluatedKey: ref.state.lastEvaluatedKey,
                data: {
                    value : flag,
                    limit: 100,
                },
            },
            true
        );
        request.addEventListener("load", function () {
            var response = this.responseText;
            try {
                response = JSON.parse(response);
                if (response._resultflag && response._resultflag == 1) {
                    let loadMoreItems = loadmore
                        ? [...ref.state.items, ...response.items]
                        : response.items;
                    if (response.items.length > 99) {
                        ref.setState({
                            loadMoreDisplay: true,
                        });
                    } else {
                        ref.setState({
                            loadMoreDisplay: false,
                        });
                    }
                    ref.setState(
                        {
                            response: response,
                            items: loadMoreItems,
                            lastEvaluatedKey: response.lastEvaluatedKey,
                            postCount: response.countdata.Count,
                        },
                        () => {
                            $("#loader").css({ display: "none" });
                        }
                    );
                }
            } catch (ex) { }
        });
    };

    render() {

        var bread = "Har Ghar Vikas / Moderation (Disabled Posts)";
        var pagelink = "/gujaratelection/moderation";
        if (this.props.match.params.status == "disabled") {
            bread = "Har Ghar Vikas/ Moderation (Disabled Posts)";
            pagelink += "/disabled";
        } else if (this.props.match.params.status == "enabled") {
            bread = "Har Ghar Vikas/ Moderation (Enabled Posts)";
            pagelink += "/enabled";
        } else {
            bread = "Har Ghar Vikas/ Moderation (Enabled Posts)";
            pagelink += "/disabled";
        }
        var items = this.state.items;
        var links = [
            {
                link: "/hargharvikas/moderation/disabled",
                name: "View Disabled Posts",
            },
            {
                link: "/hargharvikas/moderation/enabled",
                name: "View Active Posts",
            },
        ];
        var pagination = [];
        if (this.state.response && countdata) {
            var countdata = this.state.response.countdata;
            var pages = Math.ceil(countdata.Count / this.state.limit);

            for (var i = 1; i <= pages; i++) {
                pagination.push(
                    <span key={i}>
                        <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
                            {i}
                        </NavLink>
                        &nbsp;
                    </span>
                );
            }
        }

        const { selectedPhotos } = this.state;
        const { isChecked } = this.state
        return (
            <div>
                <PageTitle
                    title="#Har Ghar Vikas"
                    bread={bread}
                    links={links}
                    Count={this.state.postCount}
                />
                <div className="wrapper wrapper-content">
                    <br />
                    <div className="form-inline form_right">
                        <div>
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={() => this.flagreport("Misinformation")}
                            >
                                Misinformation
                            </button>
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={() => this.flagreport("Hateful or Abusive Content")}
                            >
                                Hateful or Abusive Content
                            </button>
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={() => this.flagreport("Spam or Misleading")}
                            >
                                Spam or Misleading
                            </button>
                            <button
                                className="btn btn-primary btn-rounded"
                                onClick={() => this.flagreport("Others")}
                            >
                                Others
                            </button>

                            <input
                                className="form-control"
                                type="text"
                                ref={(input1) => {
                                    this.input1 = input1;
                                }}
                                placeholder="Search By Name "
                                onKeyPress={(e) => {
                                    this.enterPressed(e, "1");
                                }}
                            />
                            <button
                                className="btn-success"
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                Clear filters
                            </button>
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="kamal_list">
                                <p
                                    id="nodatafound"
                                    style={{
                                        display: "none",
                                        textAlign: "center",
                                        position: "relative",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                    }}
                                >
                                    No Data Found
                                </p>
                                {Array.isArray(items) &&
                                    items.map((value, index) => {
                                        let imageArr = value.images && JSON.parse(value.images);
                                        return (
                                            <div class="file-box" key={index} id={"post_" + value.id}>
                                                <div class="file">
                                                    <a href="javascript:void(0);">
                                                        <span class="corner"></span>
                                                        <LazyLoad>
                                                            <div class="image" style={{ height: "auto" }} >
                                                                <div className="user_image_list">
                                                                    {imageArr && (
                                                                        <ul>
                                                                            {imageArr && imageArr.length > 0 &&
                                                                                imageArr.map((image, index) => {
                                                                                    return (
                                                                                        <li>
                                                                                            <a>
                                                                                                <img src={image} alt="" />
                                                                                            </a>
                                                                                        </li>
                                                                                    )
                                                                                })}
                                                                        </ul>
                                                                    )}
                                                                </div>
                                                                <div className="image_caption">
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        className="btn btn-warning btn-circle"
                                                                        onClick={() => {
                                                                            this.update(
                                                                                value.id,
                                                                                value.created,
                                                                                "disabled"
                                                                            );
                                                                        }}
                                                                        type="button"
                                                                    >
                                                                        <i className="fa fa-times"></i>
                                                                    </a>

                                                                </div>
                                                            </div>
                                                        </LazyLoad>
                                                        <div class="file-name">
                                                            {value.user_name_display ? value.user_name_display : ""}
                                                            <br />
                                                            {value.beneficiary_name ? value.beneficiary_name : ""}
                                                            <br />
                                                            <small>
                                                                Added: {value.created ? value.created : ""}
                                                            </small>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                        {this.state.loadMoreDisplay && (
                            <button
                                style={{
                                    position: "relative",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    padding: "10px 18px",
                                }}
                                type="button"
                                onClick={this.loadMoreData}
                            >
                                Load More
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/HarGharVikas/Moderation.jsx